import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";
import { Study } from "../../../../shared/entities/scripts/study";
import { DoArraysOverlap } from "../../../../shared/scripts/array-functions";
//import { FilterOption } from "../../../../shared/scripts/filtering/filtering.entities";
import { ResetDropdownFilters } from "../../../../shared/scripts/filtering/filtering.utilities";

export interface IFilteringParent {
    FilterUpdated();
}

export class FilterSection {

    parent: IFilteringParent;
    studies: Study[] = [];
    appendices: Appendix[] = [];
    sites: Site[] = [];
    allStudyIds: number[] = []; activeStudyIds: number[] = []; selectedStudyIds: number[] = [];
    allAppendixIds: number[] = []; activeAppendixIds: number[] = []; selectedAppendixIds: number[] = [];
    allSiteIds: number[] = []; activeSiteIds: number[] = []; selectedSiteIds: number[] = [];
    studySelectId: string = "#study-dropdown";
    appendixSelectId: string = "#appendix-dropdown";
    siteSelectId: string = "#site-dropdown";

    constructor(studies: Study[], appendices: Appendix[], sites: Site[], parent: IFilteringParent) {
        this.parent = parent;

        this.studies = studies;
        this.appendices = appendices;
        this.sites = sites;
        this.allStudyIds = this.studies.map((s: Study) => s.Id);
        this.allAppendixIds = this.appendices.map((a: Appendix) => a.Id);
        this.allSiteIds = this.sites.map((s: Site) => s.Id);
        this.initializeFilters();
        this.resetFilters();
    }

    initializeFilters(): void {
        this.setupDropdown("study", this.studySelectId, "Platforms");
        this.setupDropdown("appendix", this.appendixSelectId, "Trials");
        this.setupDropdown("site", this.siteSelectId, "Sites");
    }

    setupDropdown(type: string, elementId: string, optionName: string): void {
        $(elementId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {

                let activeCount: number = 0;
                if (type == 'study') activeCount = this.activeStudyIds.length;
                else if (type == 'appendix') activeCount = this.activeAppendixIds.length;
                else if (type == 'site') activeCount = this.activeSiteIds.length;

                if (numSelected == numTotal) {
                    return "All " + optionName + "   (n = " + numSelected + ")";
                }
                else {
                    return numSelected + " of " + activeCount + " " + optionName + " Selected";
                }
            }
        });
        $(elementId).selectpicker("refresh");

        $(elementId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            let values: string[] = <string[]>($(elementId).val());
            this.filterDropdownOptions(type, values.map(i => Number(i)));
            $(elementId).selectpicker("refresh");
            this.filterUpdated(this.selectedStudyIds, this.selectedAppendixIds, this.selectedSiteIds);
        });
    }

    setDropdownOptions(type: string, elementId: string, selectedElementIds: number[], activeElementIds: number[], allElements: any[], optionParameterValue: string, optionParameterName: string): void {

        $(elementId).empty();

        allElements.forEach((element: any) => {
            let selected: boolean = false;
            let disabled: boolean = false;

            if (selectedElementIds.includes(element[optionParameterValue])) {
                selected = true;
            }

            if (!activeElementIds.includes(element[optionParameterValue])) {
                disabled = true;
                selected = false;
            }

            if (!disabled) {
                let option: any = new Option(element[optionParameterName], element[optionParameterValue], false, selected);
                $(elementId).append(option);
            }
        });
        $(elementId).selectpicker("refresh");
    }

    resetFilters(): void {
        this.selectedStudyIds = this.activeStudyIds = this.allStudyIds;
        this.selectedAppendixIds = this.activeAppendixIds = this.allAppendixIds;
        this.selectedSiteIds = this.activeSiteIds = this.allSiteIds;

        this.setDropdownOptions("study", this.studySelectId, this.selectedStudyIds, this.allStudyIds, this.studies, "Id", "Name");
        this.filterDropdownOptions("study", this.selectedStudyIds);

        ResetDropdownFilters([this.studySelectId, this.appendixSelectId, this.siteSelectId]);

        this.filterUpdated(this.activeStudyIds, this.activeAppendixIds, this.activeSiteIds);
    }

    filterDropdownOptions(type: string, currentValues: number[]) {
        if (type == 'study') {
            this.selectedStudyIds = currentValues;
            this.activeAppendixIds = this.appendices.map((a: Appendix) => {
                if (this.selectedStudyIds.includes(a.StudyId)) return a.Id;
            }).filter((id: number) => id != undefined);
            this.activeSiteIds = this.sites.map((s: Site) => {
                if (DoArraysOverlap(this.selectedStudyIds, s.StudyIds)) return s.Id;
            }).filter((id: number) => id != undefined);

            this.selectedAppendixIds = this.activeAppendixIds;
            this.selectedSiteIds = this.activeSiteIds;
        }
        else if (type == 'appendix') {
            this.selectedAppendixIds = currentValues;
        }
        else if (type == 'site') {
            this.selectedSiteIds = currentValues;
        }

        if (type != 'study') this.setDropdownOptions("study", this.studySelectId, this.selectedStudyIds, this.allStudyIds, this.studies, "Id", "Name");
        if (type != 'appendix') this.setDropdownOptions("appendix", this.appendixSelectId, this.activeAppendixIds, this.activeAppendixIds, this.appendices, "Id", "Name");
        if (type != 'site') this.setDropdownOptions("site", this.siteSelectId, this.activeSiteIds, this.activeSiteIds, this.sites, "Id", "Name");
    }

    filterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[]): void {
        this.parent.FilterUpdated();
    }

    refreshFilters(): void {
        this.filterUpdated(this.selectedStudyIds, this.selectedAppendixIds, this.selectedSiteIds);
    }
}